import React from "react";
import { observer } from "mobx-react";
import { dataSearchState } from "../state";

const years = (() => {
  const currentYear = new Date().getFullYear();
  const list = [];
  for (let y = currentYear; y >= 1980; y -= 1) {
    list.push(y);
  }
  return list;
})();

const FoundedYearInputs = observer(() => {
  const { foundedYearStart, foundedYearEnd } = dataSearchState.filterComponentData || {};

  const update = (key, value) => {
    const num = value === "" ? null : Number(value);
    dataSearchState.setFilterComponentData({
      ...dataSearchState.filterComponentData,
      [key]: Number.isNaN(num) ? null : num
    });
  };

  return (
    <div className="employeesByDeptSection">
      <div className="employeesByDeptCard">
        <div className="employeesByDeptRangeRow">
          <select
            className="employeesByDeptRangeInput"
            value={foundedYearStart ?? ""}
            onChange={e => update("foundedYearStart", e.target.value)}
          >
            <option value="">Min</option>
            {years.map(y => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
          <span className="employeesByDeptRangeDash">-</span>
          <select
            className="employeesByDeptRangeInput"
            value={foundedYearEnd ?? ""}
            onChange={e => update("foundedYearEnd", e.target.value)}
          >
            <option value="">Max</option>
            {years.map(y => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
});

export default FoundedYearInputs;

